import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const UseCaseCard = ({ 
  title, 
  description, 
  icon: Icon, 
  color, 
  tam, 
  href,
  index = 0 
}) => {
  const colorClasses = {
    violet: {
      bg: 'bg-swarm-violet/10',
      border: 'hover:border-swarm-violet/40',
      text: 'text-swarm-violet',
      glow: 'group-hover:shadow-[0_0_40px_rgba(139,92,246,0.2)]'
    },
    cyan: {
      bg: 'bg-swarm-cyan/10',
      border: 'hover:border-swarm-cyan/40',
      text: 'text-swarm-cyan',
      glow: 'group-hover:shadow-[0_0_40px_rgba(6,182,212,0.2)]'
    },
    green: {
      bg: 'bg-swarm-green/10',
      border: 'hover:border-swarm-green/40',
      text: 'text-swarm-green',
      glow: 'group-hover:shadow-[0_0_40px_rgba(16,185,129,0.2)]'
    }
  };

  const colors = colorClasses[color] || colorClasses.violet;

  return (
    <Link
      to={href || "/use-cases"}
      className={`group glass-card p-6 flex flex-col h-full transition-all duration-300 ${colors.border} ${colors.glow}`}
      style={{ animationDelay: `${index * 100}ms` }}
      data-testid={`use-case-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {/* Icon */}
      <div className={`p-3 rounded-xl ${colors.bg} ${colors.text} w-fit mb-4`}>
        <Icon className="w-6 h-6" />
      </div>

      {/* Content */}
      <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-swarm-cyan transition-colors">
        {title}
      </h3>
      <p className="text-slate-400 text-sm flex-1 mb-4">
        {description}
      </p>

      {/* TAM & CTA */}
      <div className="flex items-center justify-between pt-4 border-t border-swarm-border">
        <span className="text-xs font-mono text-slate-500">
          TAM: {tam}
        </span>
        <span className={`flex items-center gap-1 text-sm font-medium ${colors.text} group-hover:gap-2 transition-all`}>
          Learn more
          <ArrowRight className="w-4 h-4" />
        </span>
      </div>
    </Link>
  );
};

export default UseCaseCard;
